import {
  ActionHeader,
  newNavigateActionHeader,
  EntityActionType,
  NavigateType,
} from '@decisions/server/DecisionsFramework/ServiceLayer/Actions/';
import { getActionHeadersForAnyEntity } from '@decisions/server/DecisionsFramework/ServiceLayer/Actions/Common/CommonActionService';
import { createSeparator } from 'utils/ActionUtils';
import { PlatformEntityData } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Folder/PlatformEntityData';
import { searchPlatformEntity } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Folder/FolderService';
import { PagingSearchResult } from 'components/inputs/SearchBox';
import { startsWith } from 'utils/StringUtils';

export async function searchItems(
  text: string,
  loadedCount: number,
  pageSize: number
): Promise<PagingSearchResult<PlatformEntityData>> {
  const textToSearch = parseSearchSwitch(text, (window as any).Decisions?.Navigation?.currentFolderId);
  const items = await searchPlatformEntity({
    textToSearch,
    entityType: null as any,
    excludeHidden: true,
    searchDescription: true,
    createdBefore: null,
    createdAfter: null,
    createdByMe: false,
    lastUpdatedByMe: false,
    updatedAfter: null,
    notUpdatedAfter: null,
    tags: null as any,
    rootFolderId: null as any,
    folderSearchType: null,
    desiredResultCount: pageSize,
    startFrom: loadedCount,
  });

  return {
    items,
    hasNext: items.length >= pageSize,
  };
}

export async function getActions(entity: PlatformEntityData): Promise<ActionHeader[]> {
  const actionsHeader = await getActionHeadersForAnyEntity({
    actionTypes: [EntityActionType.Mvc],
    typeName: entity.Type,
    entityID: entity.Id,
  });

  let additionalActions: ActionHeader[] = [];
  if (entity.Type === 'DecisionsFramework.ServiceLayer.Services.Folder.Folder') {
    additionalActions = getAdditionalActionsForFolder(entity);
  }

  return [...additionalActions, ...actionsHeader];
}

function getAdditionalActionsForFolder(entity: PlatformEntityData): ActionHeader[] {
  const folderId = entity.Id;
  return [
    newNavigateActionHeader({
      Flg: '010000000',
      Nm: `Open ${entity.Name} Folder`,
      Or: -1000,
      Id: `E|!~|${entity.Id}|!~|${entity.Type}|!~|Open Folder ${entity.Name}|!~|`,
      Ni: `${folderId}|${null}|${NavigateType.Default}`,
      Tp: 'DecisionsFramework.ServiceLayer.Actions.Common.NavigateToFolderAction',
      HT: 'SHMT',
    }),
    newNavigateActionHeader({
      Flg: '010000000',
      Nm: `Open ${entity.Name} Folder in new window`,
      Or: -1000,
      Id: `E|!~|${entity.Id}|!~|${entity.Type}|!~|Open Folder${entity.Name}in new window|!~|`,
      Ni: `${folderId}|${null}|${NavigateType.NewWindow}`,
      Tp: 'DecisionsFramework.ServiceLayer.Actions.Common.NavigateToFolderAction',
      HT: 'SHMT',
    }),
    createSeparator(-999),
  ];
}

export function parseSearchSwitch(term: string, folderId: string): string {
  if (startsWith(term, '-current')) {
    term = term.replace('-current', '');
    term = `folder:${encodeURI(folderId)} ${term.trim()}`;
  } else if (startsWith(term, '-below')) {
    term = term.replace('-below', '');
    term = `below:${encodeURI(folderId)} ${term.trim()}`;
  }

  return term;
}
